import {
  collection,
  doc,
  deleteDoc,
  getDoc,
  getDocs,
  limit,
  orderBy,
  query,
  serverTimestamp,
  setDoc,
  startAt,
  where,
} from "firebase/firestore";
import { db } from "../firebase";

export async function getSaint(id) {
  const snap = await getDoc(doc(db, "saints", id));
  if (!snap.exists()) return null;
  return { id: snap.id, ...snap.data() };
}

export async function saveSaint(id, payload, { existingRand } = {}) {
  const data = {
    ...payload,
    rand: existingRand ?? Math.random(),
    updatedAt: serverTimestamp(),
  };

  await setDoc(doc(db, "saints", id), data, { merge: true });
  return { ok: true, message: `Saved: saints/${id}` };
}

function randomFloat01() {
  // Better RNG than Math.random when available
  if (typeof crypto !== "undefined" && crypto.getRandomValues) {
    const buf = new Uint32Array(1);
    crypto.getRandomValues(buf);
    return buf[0] / 2 ** 32; // [0, 1)
  }
  return Math.random();
}

export async function createSaint(id, payload) {
  const data = {
    ...payload,
    rand: randomFloat01(),
    updatedAt: serverTimestamp(),
  };
  await setDoc(doc(collection(db, "saints"), id), data, { merge: false });
  return data;
}


/**
 * Rename a saint document id (slug):
 * - Writes a new document at `toId`
 * - Deletes the old document at `fromId`
 * - Refuses to overwrite an existing `toId`
 */
export async function renameSaint(fromId, toId, payload, { existingRand } = {}) {
  if (!fromId) throw new Error("Missing fromId.");
  if (!toId) throw new Error("Missing toId.");
  if (fromId === toId) {
    // treat as normal save
    return saveSaint(fromId, payload, { existingRand });
  }

  const toRef = doc(db, "saints", toId);
  const toSnap = await getDoc(toRef);
  if (toSnap.exists()) {
    return {
      ok: false,
      message: `Cannot rename: saints/${toId} already exists.`,
    };
  }

  const data = {
    ...payload,
    rand: existingRand ?? Math.random(),
    updatedAt: serverTimestamp(),
  };

  // Create the new doc (don't merge—this is a "fresh" doc)
  await setDoc(toRef, data, { merge: false });

  // Delete old doc
  await deleteDoc(doc(db, "saints", fromId));

  return { ok: true, message: `Renamed: saints/${fromId} → saints/${toId}` };
}

export async function deleteSaint(id) {
  await deleteDoc(doc(db, "saints", id));
}

export async function fetchPendingSaints() {
  const q = query(collection(db, "saints"), where("approved", "==", false));
  const snap = await getDocs(q);
  return snap.docs.map((d) => ({ id: d.id, ...d.data() }));
}
